import { render, staticRenderFns } from "./rubrik.vue?vue&type=template&id=8b783c56&"
import script from "./rubrik.vue?vue&type=script&lang=js&"
export * from "./rubrik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports